module.exports = __webpack_public_path__ + "static/media/logo-green.7ad9b8bd.png";